import script from "./RatePriceField.vue?vue&type=script&setup=true&lang=js"
export * from "./RatePriceField.vue?vue&type=script&setup=true&lang=js"

import "./RatePriceField.vue?vue&type=style&index=0&id=eea8382e&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-eea8382e"]])

export default __exports__